module.exports = __webpack_public_path__ + "img/F1g.ba3ec6ea.svg";